import {Component, Input, OnInit} from '@angular/core';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {ConfService} from '../../conf.service';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {SettingsComponent} from '../settings.component';
import {AttributeDescriptionComponent} from '../../crudapi/crudapi.component';
import {MatDialog} from '@angular/material';


export interface AttributeColumn {
  name: string;
  headerDisplayName: string;
  type: 'input' | 'selector' | 'checkbox' | 'more';
  placeholder?: string;
  selectableOptions?: string[];
  optionsDisplayNames?: string[];
  description?: string;
  disabled: boolean;
  disabledPlaceholder?: string;
  dataTypeFilter?: any;
}

@Component({
  selector: 'app-dynamic-form-builder',
  templateUrl: './dynamic-form-builder.component.html',
  styleUrls: ['./dynamic-form-builder.component.scss']
})
export class DynamicFormBuilderComponent implements OnInit {

  form_attributes: any;
  default_attributes = [
    {
      type: 'text_field',
      name: 'First Name',
      required: true,
      description: ''
    },
    {
      type: 'text_field',
      name: 'Last Name',
      required: true,
      description: ''
    },
    {
      type: 'text_field',
      name: 'Email',
      required: true,
      description: ''
    },
    {
      type: 'text_field',
      name: 'organization',
      required: false,
      description: 'Your company name'
    },
    {
      type: 'selectable_field',
      name: 'Gender',
      required: true,
      description: 'Your company name',
      options: ['Male', 'Female', 'Other']
    }
  ];

  origConfig: any;
  item: any;
  settingsLoading = true;
  @Input() partner = localStorage.getItem('partner');
  @Input() account = localStorage.getItem('account');

  fieldTypes = [
    {field: 'text_field', displayName: 'Text Input'},
    {field: 'selectable_field', displayName: 'Dropdown'},
  ];

  @Input() enableDisplayPolicyField = false;
  @Input() tableDefinition: AttributeColumn[] = [
    {
      name: 'displayName',
      headerDisplayName: 'Display Name',
      type: 'input',
      placeholder: 'Display Name',
      description: 'Display Name',
      disabled: false
    },
    {
      name: 'attributeName',
      headerDisplayName: 'Name',
      type: 'input',
      placeholder: 'Attribute Name',
      selectableOptions: [],
      description: 'Name of the Attribute',
      disabled: false
    },
    {
      name: 'type',
      headerDisplayName: 'Data Type',
      type: 'selector',
      selectableOptions: ['Integer', 'String'],
      disabled: false
    },
    {
      name: 'fieldType',
      headerDisplayName: 'Form Field Type',
      type: 'selector',
      selectableOptions: ['text_field', 'selectable_field'],
      optionsDisplayNames: ['Text Input', 'Dropdown'],
      disabled: false
    },
    {
      name: 'size',
      headerDisplayName: 'Size',
      type: 'input',
      placeholder: 'Size',
      disabled: false
    },
    {
      name: 'precision',
      headerDisplayName: 'Precision',
      type: 'input',
      placeholder: 'Precision',
      disabled: false
    },
    {
      name: 'attributeType',
      headerDisplayName: 'Key',
      type: 'selector',
      selectableOptions: ['None', 'Primary', 'Unique'],
      disabled: false
    },
    {
      name: 'required',
      headerDisplayName: 'Required',
      type: 'checkbox',
      description: 'Required',
      disabled: false
    },
    {
      name: 'autoIncrement',
      headerDisplayName: 'Auto-Increment',
      type: 'checkbox',
      description: 'Auto-Increment',
      disabled: false
    },
    {
      name: 'description',
      headerDisplayName: 'Description',
      type: 'input',
      placeholder: 'Description',
      selectableOptions: [],
      description: 'Name of the Attribute',
      disabled: false
    }
  ];


  @Input() newAttribute = {
    fieldType: 'text_field',
    attributeType: 'None'
  };

  @Input() formAttributes = [
    {
      attributeName: 'Field 1',
      type: 'String',
      fieldType: 'text_field',
      required: true,
      attributeType: 'None'

    },
    {
      attributeName: 'Field 2',
      type: 'String',
      fieldType: 'text_field',
      required: true,
      attributeType: 'None'
    }
  ];

  updating = false;

  constructor(public dialog: MatDialog, private confPost: ConfService, public settingComp: SettingsComponent, private appComp: AppComponent, public platform: LeftpanelComponent) { }

  async ngOnInit() {
    if (this.platform.loadingForTheFirstTime === true && this.platform.loadingForTheFirstTimeCompleted === false) {
      this.platform.initialisePlatform();
    }

    if (!this.settingComp.item) {
      this.settingComp.setcolumnvalues();
    }

    // if (this.partner === localStorage.getItem('partner')) {
    //   if (this.platform.settingsData !== null && this.platform.settingsData !== undefined) {
    //     this.item = this.platform.settingsData['body'][0];
    //     this.setDevexConfigs();
    //     this.settingsLoading = false;
    //   } else {
    //     await this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
    //       if (response['body'] && response['body'][0]) {
    //         this.platform.settingsData = response;
    //         this.item = response['body'][0];
    //         this.setDevexConfigs();
    //         this.settingsLoading = false;
    //       }
    //     });
    //   }
    // } else {
    //   await this.confPost.getSettingsV2CRUD(this.partner, this.account, false).subscribe(response => {
    //     if (response['body'] && response['body'][0]) {
    //       this.item = response['body'][0];
    //       this.setDevexConfigs();
    //       this.settingsLoading = false;
    //     }
    //   });
    // }
    this.settingsLoading = false;
  }

  drop(event: CdkDragDrop<Object[]>) {
    moveItemInArray(this.form_attributes, event.previousIndex, event.currentIndex);
  }

  attributeDrop(event: CdkDragDrop<Object[]>) {
    moveItemInArray(this.formAttributes, event.previousIndex, event.currentIndex);
  }

  dropOption(event: CdkDragDrop<Object[]>, options) {
    moveItemInArray(options, event.previousIndex, event.currentIndex);
  }

  deleteAttribute(index) {
    this.form_attributes.splice(index, 1);
  }

  deleteAttributeField(index) {
    this.formAttributes.splice(index, 1);
  }


  deleteFieldOption(options, i) {
    options.splice(i, 1);
  }

  addFieldOption(options) {
    options.push('Option');
  }

  addFormField() {
    this.form_attributes.push({
      type: 'text_field',
      name: 'Name',
      required: false,
      description: ''
    });
  }

  addAttributeField() {
    this.formAttributes.push(JSON.parse(JSON.stringify(this.newAttribute)));
  }

  trackByFn(index: any, item: any) {
    return index;
  }

  fieldTypeChange(value) {
    if (value.options) {
      delete value['options'];
    }
    if (value.type === 'selectable_field') {
      value['options'] = ['Option 1', 'Option 2', 'Option 3'];
    }
  }

  async openAttributeDescriptionDialog(header, definition) {
    const data = {
      'displayName': definition.displayName,
      'description': definition.description,
      'dataStoragePolicy': definition.dataStoragePolicy,
      'apiAccessPolicy': definition.apiAccessPolicy,
      'displayPolicy': definition.displayPolicy,
      'definitionType': definition.type,
      'datatypeFilter': header.dataTypeFilter,
      'disableDisplayNameField': true,
      'enableDisplayPolicyFieldByDefault': this.enableDisplayPolicyField
    };
    const dialogRef = this.dialog.open(AttributeDescriptionComponent, {
      data: data
    });

    const result = await dialogRef.afterClosed().toPromise();
    definition.description = data.description;
    definition.dataStoragePolicy = data.dataStoragePolicy;
    definition.apiAccessPolicy = data.apiAccessPolicy;
    definition.displayPolicy = data.displayPolicy;

  }
}
